// ─── Types ──────────────────────────────────────────────────────────
// ─── Initial State ──────────────────────────────────────────────────
export const initialSettingsState = {
    soundEnabled: true,
    soundVolume: 0.7,
    hapticsEnabled: true,
    cardBack: 'classic',
    tableTheme: 'green',
    animationsEnabled: true,
    autoSortHand: true,
    showTrumpIndicator: true,
    confirmCardPlay: false,
    showTurnNotifications: true,
    language: 'en',
};
// ─── Actions ────────────────────────────────────────────────────────
export function toggleSound(state) {
    return { ...state, soundEnabled: !state.soundEnabled };
}
export function setSoundVolume(state, volume) {
    return { ...state, soundVolume: Math.max(0, Math.min(1, volume)) };
}
export function toggleHaptics(state) {
    return { ...state, hapticsEnabled: !state.hapticsEnabled };
}
export function setCardBack(state, cardBack) {
    return { ...state, cardBack };
}
export function setTableTheme(state, tableTheme) {
    return { ...state, tableTheme };
}
export function toggleAnimations(state) {
    return { ...state, animationsEnabled: !state.animationsEnabled };
}
export function toggleAutoSort(state) {
    return { ...state, autoSortHand: !state.autoSortHand };
}
export function toggleConfirmPlay(state) {
    return { ...state, confirmCardPlay: !state.confirmCardPlay };
}
export function toggleTurnNotifications(state) {
    return { ...state, showTurnNotifications: !state.showTurnNotifications };
}
export function setLanguage(state, language) {
    return { ...state, language };
}
export function resetSettings() {
    return { ...initialSettingsState };
}
//# sourceMappingURL=settingsStore.js.map